import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import Swal from "sweetalert2";
import { Contactusapi, contentApi } from "../network/Network";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TimePicker from "../Components/TimePicker";
import Checkcall from "../Components/Checkcall";
import Videoforcall from "../Components/Videoforcall";
import AgoraVideoCall from "../Components/AgoraVideoCall";
import EnhancedOneToOneCall from "../Components/EnhancedOneToOneCall";

const ContactUs = () => {
  let currentUrl = window.location.href.split("/");
  const [getapi, setGetapi] = useState("");
  const sitesetting = useSelector((state) => state?.Auth?.sitesetting);
  const [formErrors, setFormErrors] = useState({});
  const [formSuccess, setFormSuccess] = useState({});
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const validateField = (name, value) => {
    let error = "";
    let success = "";

    switch (name) {
      case "first_name":
        if (!value.trim()) {
          error = "First Name is required.";
        } else {
          success = "Looks good!";
        }
        break;

      case "last_name":
        if (!value.trim()) {
          error = "Last Name is required.";
        } else {
          success = "Looks good!";
        }
        break;

      case "email":
        if (!value.trim()) {
          error = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = "Email is invalid.";
        } else {
          success = "Looks good!";
        }
        break;

      case "phone":
        if (!value.trim()) {
          error = "Phone number is required.";
        } else if (value.length < 8 || value.length > 10) {
          error = "Phone number must be between 8 to 10 digits.";
        } else {
          success = "Looks good!";
        }
        break;

      case "message":
        if (!value.trim()) {
          error = "Message is required.";
        } else {
          success = "Looks good!";
        }
        break;

      default:
        break;
    }

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (error) {
        newErrors[name] = error;
      } else {
        delete newErrors[name];
      }
      return newErrors;
    });

    setFormSuccess((prevSuccess) => {
      const newSuccess = { ...prevSuccess };
      if (success) {
        newSuccess[name] = success;
      } else {
        delete newSuccess[name];
      }
      return newSuccess;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value); 
  };

  useEffect(() => {
    contentApi(currentUrl[3])
      .then((res) => {
        setGetapi(res?.data);
      })
      .catch(() => {});
  }, []);

  const validateForm = () => {
    let isValid = true;
    Object.keys(userData).forEach((field) => {
      validateField(field, userData[field]);
      if (!userData[field] || formErrors[field]) {
        isValid = false;
      }
    });
    return isValid;
  };
// Contact Us Functionalaity 
  const Contactus = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    Contactusapi(userData)
      .then(() => {
        Swal.fire({
          icon: "success",
          text: "Thank You For Submitting Your Query",
        });
        setUserData({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          message: "",
        });
        setFormErrors({});
        setFormSuccess({});
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: "Failed to submit your query. Please try again.",
        });
      })
      .finally(() => setLoading(false));
  };
  // =========================

  return (
    <>
      <Header />
      <PageHeader pagename="Contact Us" />
      <section className="contact-us">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 ">
              <h2 className="main-heading-font dark-color level-2 text-start wow animate__animated animate__zoomIn mb-4">
                Let's Progress Together
              </h2>
              <form>
                <div className="row">
                  <div className="form-group col-lg-6">
                    <input
                      type="text"
                      className={`form-control mb-2 ${
                        formErrors.first_name ? "is-invalid" : ""
                      } ${formSuccess.first_name ? "is-valid" : ""}`}
                      id="firstName"
                      placeholder="First Name"
                      name="first_name"
                      onChange={handleChange}
                      value={userData.first_name}
                    />
                    <div className="invalid-feedback mb-2">
                      {formErrors.first_name}
                    </div>
                  </div>
                  <div className="form-group col-lg-6">
                    <input
                      type="text"
                      className={`form-control mb-2 ${
                        formErrors.last_name ? "is-invalid" : ""
                      } ${formSuccess.last_name ? "is-valid" : ""}`}
                      id="lastName"
                      placeholder="Last Name"
                      name="last_name"
                      onChange={handleChange}
                      value={userData.last_name}
                    />
                    <div className="invalid-feedback mb-2">
                      {formErrors.last_name}
                    </div>
                  </div>
                </div>
                <div className="form-group col-lg-12">
                  <input
                    type="email"
                    className={`form-control mb-2 ${
                      formErrors.email ? "is-invalid" : ""
                    } ${formSuccess.email ? "is-valid" : ""}`}
                    id="email"
                    placeholder="Enter email"
                    name="email"
                    onChange={handleChange}
                    value={userData.email}
                  />
                  <div className="invalid-feedback mb-2">
                    {formErrors.email}
                  </div>
                </div>
                <div className="form-group col-lg-12">
                  <input
                    type="tel"
                    className={`form-control mb-2 ${
                      formErrors.phone ? "is-invalid" : ""
                    } ${formSuccess.phone ? "is-valid" : ""}`}
                    id="phone"
                    placeholder="Enter phone number"
                    name="phone"
                    onChange={handleChange}
                    value={userData.phone}
                  />
                  <div className="invalid-feedback mb-2">
                    {formErrors.phone}
                  </div>
                </div>
                <div className="form-group col-lg-12">
                  <textarea
                    className={`form-control ${
                      formErrors.message ? "is-invalid" : ""
                    } ${formSuccess.message ? "is-valid" : ""}`}
                    id="message"
                    rows="4"
                    placeholder="Enter Message"
                    name="message"
                    onChange={handleChange}
                    value={userData.message}
                  />
                  <div className="invalid-feedback mb-2">
                    {formErrors.message}
                  </div>
                </div>
            
                <Link
                  className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none __web-inspector-hide-shortcut__"
                  to="/contact-us"
                  onClick={Contactus}
                  disabled={loading}
                >
                  <span className="loading-btn loading bg-wrapper w-100">
                    Submit
                  </span>
                </Link>
              </form>
            </div>
            <div className="col-lg-6 mt-5 ps-4">
              <p className="primary-regular-font extra-color-5 level-7 mt-3">
                {getapi?.paragraph}
              </p>
              <div className="address-wrapper extra-bg-8 radius-20 p-4">
                <div className="main-address-detail d-flex align-items-center gap-4">
                  <h4 className="secondary-bold-font level-7-lg mb-0">
                    Address:
                  </h4>
                  <p className="mb-0">{sitesetting?.address}</p>
                </div>
                <div className="main-address-detail mt-2 d-flex align-items-center gap-4">
                  <h4 className="secondary-bold-font level-7-lg mb-0">
                    Email:
                  </h4>
                  <p className="mb-0">{sitesetting?.contact_email}</p>
                </div>
                <div className="main-address-detail border-top mt-3 pt-3 d-flex align-items-center gap-4">
                  <h4 className="secondary-bold-font level-7-lg mb-0">
                    Availability:
                  </h4>
                  <p className="mb-0">From Monday to Saturday: 9am - 9pm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ContactUs;
